import React from "react";
import { SortableContainer, SortableElement } from "react-sortable-hoc";

// Components
import TrainingDocItem from "./TrainingDocItem";

// Make the wrapped element sortable
const SortableItem = SortableElement(TrainingDocItem);

export default SortableContainer(props => {
	const { files, group } = props;

	return (
		<div className="group-document-container">
			{files.map((file, i) => (
				<SortableItem
					key={`file-${i}`}
					index={i}
					file={file}
					group={group}
					i={i}
					{...props}
				/>
			))}
		</div>
	);
});



// WEBPACK FOOTER //
// ./src/components/admin/training-documents/SortableDocumentList.js